 <!--Full width header Start-->
<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!--Full width header End-->
<!-- Main content Start -->
<div class="main-content">
  <!-- Breadcrumbs Start -->
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">{{ profile()?.name || 'Balaji Sevasamithi' }}</h1>
      <ul>
        <li><a class="active" [routerLink]="['/']">Home</a></li>
        <li><a>About</a></li>
        <li>{{ profile()?.name || 'Balaji Sevasamithi' }}</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumbs End -->
  <!-- Blog Section Start -->
  <div *ngIf="profile()" class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <about-menu></about-menu>
        </div>
        <div class="col-lg-8">
          <!-- About Section Start -->
          <div id="rs-about" class="rs-about style1">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-6 order-last padding-0 md-pl-15 md-pr-15 md-mb-30">
                  <div class="img-part">
                    <img [src]="profile()?.image" [alt]="profile()?.name || ''">
                  </div>
                </div>
                <div class="col-lg-6 pr-70 md-pr-15">
                  <div class="sec-title">
                    <div class="sub-title orange">{{ profile()?.name }}</div>
                    <div class="desc" *ngFor="let description of profile()?.descriptions" [innerHTML]="description">

                    </div>
                  </div>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-lg-12 pr-70 md-pr-15">
                  <div class="sec-title">
                    <div class="desc" *ngFor="let description of profile()?.additionalDescriptions" [innerHTML]="description">

                    </div>
                    <div class="row mt-30">
                      <div class="col-md-6 mb-20">
                        <img src="https://jntuanotifications.blob.core.windows.net/websites/images/BALAJI SEVA SAMITHI1.png" class="img-fluid" alt="Balaji Seva Samithi Activity 1">
                      </div>
                      <div class="col-md-6 mb-20">
                        <img src="https://jntuanotifications.blob.core.windows.net/websites/images/BALAJI SEVA SAMITHI2.png" class="img-fluid" alt="Balaji Seva Samithi Activity 2">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- About Section End -->
        </div>
      </div>
    </div>
  </div>
  <!-- Blog Section End -->
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
